import { render, staticRenderFns } from "./column-chart.vue?vue&type=template&id=2c3b2347&"
import script from "./column-chart.vue?vue&type=script&lang=js&"
export * from "./column-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports